import { Layout } from 'antd';

import { environment } from '../../environment/environment';

const year = new Date().getFullYear();

export const FooterComponent = () => {
  return (
    <Layout.Footer>
      <span>Copyright © {year} TryCycle Data Systems Inc. All rights reserved. </span>
      <span>
        Version: {environment.versionNumber}.{environment.buildNumber}{' '}
      </span>
      <span>
        Questions? Email{' '}
        <a href="mailto:support@trycycle.ca" target="_blank" rel="noreferrer">
          support@trycycle.ca
        </a>
        .
      </span>
    </Layout.Footer>
  );
};
